import { render, staticRenderFns } from "./withdraw-detail.vue?vue&type=template&id=30de0600&scoped=true&"
import script from "./withdraw-detail.vue?vue&type=script&lang=js&"
export * from "./withdraw-detail.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-detail.vue?vue&type=style&index=0&id=30de0600&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30de0600",
  null
  
)

export default component.exports